// @flow
import { Box, Grid, MenuItem, Select, Stack, Typography } from '@mui/material';
import { Article } from '@mui/icons-material';
import useI18n from '@shared/helper/hooks/useI18n';
import AgGrid from '@shared/components/agGrid';
import DateTimeCellRenderer from '@shared/components/cellRenderer/dateTime';
import StatusCellRenderer from '@shared/components/cellRenderer/status';
import { useSearchParams } from 'react-router-dom';
import type { activityReportPropsType } from '@shared/model/components/activityReportPropsType';

function ActivityReport({ service }: activityReportPropsType): React$Node {
	const { translate } = useI18n('finoShared');

	const defaultColDef = {
		sortable: false,
		resizable: true,
	};

	const columnDefs = [
		{
			headerName: translate('activityType'),
			field: 'description',
		},
		{
			headerName: translate('dateAndTime'),
			field: 'dateTime',
			cellRendererFramework: DateTimeCellRenderer,
		},
		{
			headerName: translate('ip'),
			field: 'clientInfo.ip',
		},
		{
			headerName: translate('status'),
			field: 'isSuccess',
			cellRendererFramework: StatusCellRenderer,
		},
	];

	const [searchParams, setSearchParams] = useSearchParams();

	function selectPageSize(event) {
		const previousSearchParams = Object.fromEntries(searchParams);
		const pageSize = event.target.value;
		setSearchParams({
			...previousSearchParams,
			pageSize,
			page: 1,
		});
	}

	return (
		<Box component={'section'}>
			<Stack
				direction={'row'}
				alignItems={'center'}
				spacing={1}
			>
				<Article />
				<Typography variant={'h3'}>
					{translate('yourActivityReport')}
				</Typography>
			</Stack>
			<Grid container mb={3} justifyContent={'end'}>
				<Grid item xs={12} sm={3} md={2} xl={1}>
					<Select
						value={Object.fromEntries(searchParams)?.pageSize || 5}
						onChange={(value) => selectPageSize(value)}
						variant={'filled'}
						fullWidth
						hiddenLabel
						disableUnderline
					>
						<MenuItem value={5}>{'5'}</MenuItem>
						<MenuItem value={10}>{'10'}</MenuItem>
						<MenuItem value={50}>{'50'}</MenuItem>
					</Select>
				</Grid>
			</Grid>
			<AgGrid
				service={service}
				defaultColDef={defaultColDef}
				columns={columnDefs}
				dataKey={'content.items'}
				totalRecordKey={'content.totalItems'}
				name={'activityList'}
			/>
		</Box>
	);
}

export default ActivityReport;
